/**
 * Plan-level RM map migration helper.
 *
 * Wraps `migrateDupRm12ToPlan` + `migrateApreRmToPlan` so callers in
 * the data layer can run the lazy migration in a single call. Returns
 * the (same, mutated) plan instance so it can be inlined into write
 * pipelines:
 *
 *   localStorage.setItem(KEY, JSON.stringify(ensurePlanMigrated(plan)));
 *
 * Called from every plan write path (savePlan, updatePlanProgress,
 * sync/download, usePlanLoader's commit) so the canonical maps stay
 * populated even when the on-mount useEffect in useTrainingPlan misses
 * the first-login race (plan arrives via backend fetch AFTER mount,
 * which the on-mount migrator does not see).
 */
import { migrateDupRm12ToPlan, migrateDupWeightsToPlan } from './training/dup';
import { migrateApreRmToPlan } from './training/apre';

export function ensurePlanMigrated<T extends Record<string, any> | null | undefined>(plan: T): T {
  if (!plan || typeof plan !== 'object') return plan;
  try {
    migrateDupRm12ToPlan(plan as any);   // v2 (rm12 map) — legacy back-compat
    migrateDupWeightsToPlan(plan as any); // v3 (per-rep-range) — canonical
    migrateApreRmToPlan(plan as any);
  } catch (e) {
    // Migration is opportunistic — never crash the data write path.
     
    console.error('[ensurePlanMigrated] failed:', e);
  }
  return plan;
}
